import i18next from 'i18next';

export const ERR_DUPLICATE_NAMES = i18next.t('ErrorMessages.DuplicateNames');
export const ERR_BLANK_FIELDS = i18next.t('ErrorMessages.BlankFields');
export const VALID_INTEGERS = i18next.t('ErrorMessages.ValidIntegers');
export const ERR_GROUP_SELECT = i18next.t('ErrorMessages.GroupSelect');
export const ERR_NO_FILTERS = i18next.t('ErrorMessages.NoFilters');
export const ERR_NETWORK = i18next.t('ErrorMessages.Network');
